/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/warenkorb-entry-dtp-zusatzdaten.ts.
 */
import {User} from './user';
import {DtpZusatzdatentyp} from './dtp-zusatzdatentyp';

/**
 * Zweck: Beschreibt class WarenkorbEntryDtpZusatzdaten und ihren Daten- oder Funktionsvertrag.
 */
export class WarenkorbEntryDtpZusatzdaten {
  id: number;
  matchcode: string;
  data: any;
  file: any;
  zusatzdaten: DtpZusatzdatentyp;
  tsUpdated: string;
  updatedBy: User;
  defect: boolean;
  defectNote: string;
  validationError: string;
  dsgvoManualBlackening: boolean;
  dsgvoAutoBlackening: boolean;
  lastError: {
    id: number;
    comment: string;
    stateOpen: boolean;
  };
}
